export const isRehydrated = state => state._persist.rehydrated;
